export default "__VITE_ASSET__38dd822b__"